import { ApiWrapper } from '../api';
import { LoginData } from '../entities';

export class LoginAPI {
    loginUser(username: string, password: string): Promise<LoginData> {
        return ApiWrapper.performRequest(
            'POST',
            '/v1/auth/admin-login',
            {
                body: { username, password }
            });
    }
}
